

























import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Customer from '@/domain/customer/entity/customer.entity';

import CustomerService from '@/domain/customer/service/customer.service';
import MultipleSelectComponent from './multiple-select.component.vue';

@Component({
  components: {
    'label-slot': LabelSlot,
    MultipleSelectComponent,
  },
})
export default class SearchAllCustomerComponent extends Vue {
  @Prop({ default: 'Buscar Por...' }) labelBy!: string;

  @Prop({ default: 'Valor...' }) labelValue!: string;

  @Prop({ type: String, required: true }) businessUnitId!: string;

  customerOptions = [
    {
      value: 'name',
      description: 'Razão Social',
    },
    {
      value: 'tradingName',
      description: 'Nome Fantasia',
    },
  ]

  customers: Customer[] = [];

  selectedCustomers: string[] = [];

  loading: boolean = false;

  customerOptionField: string = 'name';

  updateField(field: string, value) {
    this.$emit(`update:${field}`, value);
  }

  sendForm() {
    this.$emit('sendForm');
  }

  async getCustomerOptions(searchValue: string) {
    this.loading = true;
    try {
      const customers = await CustomerService
        .getAllByNameOrTradingName(this.customerOptionField, searchValue, this.businessUnitId);
      this.customers = customers;
    } catch (e) {
      this.customers = [];
    }
    this.loading = false;
  }

  selected(customers: string[]) {
    this.selectedCustomers = customers;
    this.$emit('selected', customers);
  }
}
